import React, { FC } from 'react';

import '@frete.com/fuel-fonts/satoshi/fontface.css';
import Profile from 'components/page/Profile';
import { Providers } from 'providers';
import { useOutletContext } from 'react-router-dom';
import { ITruckerProfileContextProps } from 'types';

export const TruckerProfile: FC = () => (
  <>
    {useOutletContext<ITruckerProfileContextProps>() && (
      <Providers withToastProvider>
        <Profile />
      </Providers>
    )}
  </>
);

export default TruckerProfile;
